import { runtimeConfig } from '../config/runtime';

interface AppHeaderProps {
  userLabel: string;
  loadedAt: Date | null;
  refreshing: boolean;
  onOpenControls: () => void;
  onSignOut?: () => void;
}

export function AppHeader({
  userLabel,
  loadedAt,
  refreshing,
  onOpenControls,
  onSignOut,
}: AppHeaderProps) {
  return (
    <header className="app-header">
      <div className="brand-block">
        <div className="brand-mark" aria-hidden="true">
          BSC
        </div>
        <div>
          <div className="brand-company">{runtimeConfig.companyName}</div>
          <div className="brand-subtitle">Balanced Scorecard</div>
        </div>
      </div>

      <div className="header-actions">
        <div className="header-meta" aria-live="polite">
          <span className={refreshing ? 'sync-dot sync-dot--active' : 'sync-dot'} />
          <span>
            {refreshing
              ? 'Aggiornamento in corso…'
              : loadedAt
                ? `Dati letti alle ${loadedAt.toLocaleTimeString('it-IT', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}`
                : 'Dati non ancora caricati'}
          </span>
        </div>

        <button className="button button--secondary" type="button" onClick={onOpenControls}>
          Controlli
        </button>

        <div className="user-menu">
          <span className="user-label" title={userLabel}>
            {userLabel}
          </span>
          {onSignOut ? (
            <button className="button button--ghost" type="button" onClick={onSignOut}>
              Esci
            </button>
          ) : null}
        </div>
      </div>
    </header>
  );
}
